import { render, staticRenderFns } from "./UsageFeesTokuyoCareInsuranceServiceCostsTable.vue?vue&type=template&id=34743872&scoped=true&lang=pug"
import script from "./UsageFeesTokuyoCareInsuranceServiceCostsTable.vue?vue&type=script&lang=ts"
export * from "./UsageFeesTokuyoCareInsuranceServiceCostsTable.vue?vue&type=script&lang=ts"
import style0 from "./UsageFeesTokuyoCareInsuranceServiceCostsTable.vue?vue&type=style&index=0&id=34743872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34743872",
  null
  
)

export default component.exports